import { render, staticRenderFns } from "./make-public-models.html?vue&type=template&id=bf19f41c&scoped=true&external"
import script from "./make-public-models.js?vue&type=script&lang=js&external"
export * from "./make-public-models.js?vue&type=script&lang=js&external"
import style0 from "./make-public-models.scss?vue&type=style&index=0&id=bf19f41c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf19f41c",
  null
  
)

export default component.exports